/**
 * @ngdoc directive
 * @name categoryHeader
 * @module flowingly.runner.setup
 * @description  This comppnent is used to display the header for the category and will contain controls
 * @usage
 * ```
       <category-header on-categories-updated="$ctrl.handleCategoriesUpdated()"></category-header>
 * ``` 
 * * #### Outputs
 * * onCategoriesUpdated: this method is called when the category list is updated.
 */
angular.module('flowingly.runner.setup').component('categoryHeader', {
  bindings: {
    onCategoriesUpdated: '&'
  },
  template: `<button
      ng-if="!$ctrl.hideActions"
      ng-click="$ctrl.openAddCategoryModal()"
      class="btn btn-primary mt-25">Add Category</button>
      <category-add-edit-modal
        ng-if="$ctrl.showAddCategoryModal"
        close-modal="$ctrl.closeAddCategoryModal"
        flow-model-editors="[]"
      />`,
  controller: [
    'APP_CONFIG',
    'sessionService',
    '$scope',
    function (APP_CONFIG, sessionService, $scope) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      var $ctrl = this;
      $ctrl.showAddCategoryModal = false;
      $ctrl.openAddCategoryModal = function () {
        $ctrl.showAddCategoryModal = true;
      };
      $ctrl.closeAddCategoryModal = function () {
        $ctrl.showAddCategoryModal = false;
      };

      let isFlowModelAdmin = sessionService.isFlowModelAdmin();
      $ctrl.hideActions =
        !!APP_CONFIG.disableAdminCategoryEdit && isFlowModelAdmin;

      $scope.$watch(
        function () {
          return APP_CONFIG.disableAdminCategoryEdit;
        },
        function (value) {
          $ctrl.hideActions = !!value && isFlowModelAdmin;
        }
      );
    }
  ]
});
